module.exports = __webpack_public_path__ + "static/media/antigua-historic-20.8b903c0d.jpg";